import { render, staticRenderFns } from "./Audio2.vue?vue&type=template&id=908b81d0&"
import script from "./Audio2.vue?vue&type=script&lang=js&"
export * from "./Audio2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports